const otpExpireTimeEnum = Object.freeze([
    {
        id: "5",
        name: "5 Minutes",
    },
    {
        id: "10",
        name: "10 Minutes",
    },
    {
        id: "15",
        name: "15 Minutes",
    },
    {
        id: "20",
        name: "20 Minutes",
    },
    {
        id: "30",
        name: "30 Minutes",
    },
    {
        id: "60",
        name: "60 Minutes",
    },
]);
export default otpExpireTimeEnum;
